export function useLawTextLabels() {
  const params = useLawRouteParams()
  const isStandardText = useIsStandardText()

  const textLabel = computed(() => {
    if (isStandardText.value) {
      return 'Standardtekst'
    }

    const lawId = params.value.lawId?.toLowerCase() ?? ''
    if (lawId.startsWith('forskrift-')) {
      return 'Forskriftstekst'
    }

    return 'Lovtekst'
  })

  const textLabelLower = computed(() => textLabel.value.toLowerCase())

  return {
    textLabel,
    textLabelLower,
  }
}